import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const FEE_PATCH_REQUEST = 'PATCH_FEE_REQUEST';
export const FEE_PATCH_FAILURE = 'PATCH_FEE_FAILURE';
export const FEE_PATCH_SUCCESS = 'PATCH_FEE_SUCCESS';

export const patchFee = (data, id) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(patchRequest());
        return axios(apiRequestOptions(apiPath.FEES.PATCH, data, { params }))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(patchSuccess(response.data));
                return response.data;
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(patchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchRequest = () => ({ type: FEE_PATCH_REQUEST });
const patchFailure = error => ({ type: FEE_PATCH_FAILURE, error });
const patchSuccess = fee => ({ type: FEE_PATCH_SUCCESS, fee });
